import CellAddress from '@/apps/MainApp/views/Dashboard/TableCells/CellAddress.vue'

export const registerDisplayAddressColumn = (dashboard) => {
  dashboard.registerColumn({
    name: 'displayAddress',
    label: 'monolith.shared.address',
    options: {
      filter: 'address',
      searchable: true,
      sortable: false,
    },
  })
}

export const registerDisplayAddressWithBuildingTypeColumn = (dashboard) => {
  dashboard.registerCustomColumn({
    name: 'displayAddress',
    label: 'monolith.shared.address',
    component: CellAddress,
    options: {
      filter: 'address',
      searchable: true,
      sortable: false,
    },
  })
}
